export default __webpack_public_path__ + "static/media/TVinsure-Covid-Card-Asia.4930ca95.jpg";